import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../utils/http-utils';
import { Page } from '../model/page';
import { environment } from '../../../environments/environment';

/**
 * Parâmetros extras para os métodos de serviço.
 */
export interface Extra {
  [key: string]: string;
}

export abstract class CrudService<T> {
  constructor(protected path: string, protected http: HttpClient) {}

  create(item: T, path: string): Observable<T> {
    const url = environment.apiUrl + this.buildPath() + path;
    return this.http.post<T>(url, item);
  }

  update(id: string, item: T): Observable<T> {
    const url = environment.apiUrl + this.buildPath() + '/' + id;

    return this.http.put<T>(url, item);
  }

  delete(id: any): Observable<any> {
    const url = environment.apiUrl + this.buildPath() + '/' + this.generatePathVariable(id);

    return this.http.delete(url);
  }

  get(id: any): Observable<T> {
    const url = environment.apiUrl + this.buildPath() + '/' + this.generatePathVariable(id);
    return this.http.get<T>(url);
  }

  findAll(): Observable<T> {
    const url = environment.apiUrl + this.buildPath();
    return this.http.get<T>(url);
  }

  search(params: HttpParams, headers?: HttpHeaders): Observable<Page<T>> {
    const url = environment.apiUrl + this.buildPath();
    return this.http.get<Page<T>>(url, { params, headers });
  }

  searchAll(): Observable<Page<T>> {
    const searchParams = {
      page: 0,
      limit: -1,
    };

    const params = HttpUtils.buildHttpParams(searchParams);

    return this.search(params, undefined);
  }

  filter(params: any, path: string): Observable<Page<any>> {
    const url = environment.apiUrl + path;
    return this.http.get<Page<any>>(url, {
      params: HttpUtils.buildHttpParams(params),
    });
  }

  /**
   * Constroi o path a ser usado para as chamadas REST.
   * Por padrão apenas o próprio valor do path é retornado.
   *
   * @param extra informação extra para criação do path.
   */
  protected buildPath(): string {
    return this.path;
  }

  protected abstract generatePathVariable(id: any): string;

  protected pipeGET(data: Date): Date {
    return data;
  }
}
